<ul class="nav flex-column nav-pills">
  @for (menu of menus; track menu) {
  <div>
    @if ((menu.hidden | async) === false) {
    <li class="nav-item">
      <a class="nav-link"
         [routerLink]="menu.url"
         [class.active]="this.isActiveOrLastMatched$(menu) | async">{{
        menu.title
        }}</a>
      @if (menu.isMatched$ | async) {
      <era-menus [menus]="menu.children$ | async"></era-menus>
      }
    </li>
    }
  </div>
  }
</ul>